import { DetailHeader } from "../../components/detailHeader/DetailHeader";
import { Box, IconButton, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import { RecordContext } from "../../components/record/Record";
import { useContext } from "react";
import { Actions } from "../../components/actionsMenu/ActionsMenu";
import { OpenInNew } from "@mui/icons-material";
import { formatDateWithTime } from "../../utils/dateUtils";
import { Avatar } from "../../components/fieldsViews/fields/Avatar";
import { renderFieldView } from "../../components/fieldsViews/renderFieldView";
import { findField } from "../../utils/findField";

type EegRecordingHeaderProps = {
    actions?: Actions;
};

export const EegRecordingHeader = ({ actions }: EegRecordingHeaderProps) => {
    const recordContext = useContext(RecordContext);

    if (!recordContext) return null;
    const client = recordContext.item?.eeg_evaluation?.eeg_session?.treatment?.client;
    const treatment = recordContext.item?.eeg_evaluation?.eeg_session?.treatment;
    const treatmentLink = `/treatments/${treatment?.id}/detail`;
    const session = recordContext.item?.eeg_evaluation?.eeg_session;
    const technician = recordContext.item?.eeg_evaluation?.eeg_session?.technician?.user_id;
    const eyesConditionField = findField(recordContext.formatedFields, "eyes_condition");



    return (
        <DetailHeader actions={actions} collection={recordContext.collection}>
            <Typography variant="h6" color="secondary">
                EEG Recording
            </Typography>
            <Grid container alignItems="flex-start" display="flex" flexWrap="nowrap" flexDirection="row" gap={5}>
                <Grid xs={12}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography
                            variant="h5"
                            color="primary"
                            component={Link}
                            sx={{ textDecoration: "none" }}
                            to={treatmentLink}
                        >
                            {client?.client_id}
                        </Typography>
                        <IconButton sx={{ ml: 2, p: 0 }} color="primary" component={Link} to={treatmentLink} target="_blank">
                            <OpenInNew />
                        </IconButton>
                    </Box>
                    <Typography variant="body1">
                        {client?.user_id?.first_name} {client?.user_id?.last_name}
                    </Typography>
                </Grid>
                <Grid xs={12}>
                    <Typography variant="h6" color="primary">
                        Avaliação
                    </Typography>
                    <Typography variant="body1">{formatDateWithTime(session?.start_date)}</Typography>
                </Grid>
                <Grid xs={12}>
                    <Typography variant="h6" color="primary">
                        Técnico EEG
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Avatar value={technician?.avatar} styles={{ width: 25, height: 25 }} />
                        <Typography variant="body1">
                            {technician?.first_name} {technician?.last_name}
                        </Typography>
                    </Box>
                </Grid>
                <Grid xs={12}>
                    <Typography variant="h6" color="primary">
                        Condição dos olhos
                    </Typography>
                    {eyesConditionField && renderFieldView(eyesConditionField, recordContext.item, "group")}
                </Grid>
            </Grid>
        </DetailHeader>
    );
};
